import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "prompt__wrapper"
}
const _hoisted_2 = { class: "prompt__item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "prompt__text" }
const _hoisted_5 = {
  key: 0,
  class: "text__title"
}
const _hoisted_6 = {
  key: 1,
  class: "text__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("img", {
              src: require(`@/assets/svg/${_ctx.iconName}`)
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              (_ctx.content)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.content), 1))
                : _createCommentVNode("", true)
            ])
          ], true),
          _createElementVNode("div", {
            class: "close_btn",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "pp-icon-cross-circle-big close-icon" }, null, -1)
          ]))
        ])
      ]))
    : _createCommentVNode("", true)
}